import { useLocation } from "react-router-dom";
const useUrlString = () => {
  const location = useLocation();
  const handleClickUrl = (id: string, urlString: string) => {
    const params = new URLSearchParams(location.search);
    const existingId = params.get("id"); // assuming ?id=... is required
    if (existingId) {
      const url = new URL(window.location.href);
      url.searchParams.set(urlString, id); // add or update param

      window.history.pushState({}, "", url.toString());
    }
  };
  const hanleClickRemoveURl = (urls: string) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(urls);
    window.history.pushState({}, "", url.toString());
  };
  return {
    handleClickUrl,
    hanleClickRemoveURl,
  };
};

export default useUrlString;
